import { makeStyles } from '@mui/styles';

import { globalTheme as theme } from '@styles';

export const useStyles = makeStyles(() => ({
  root: {
    border: `1px solid ${theme.palette.brandGray.main}`,
    borderRadius: 4,
    background: 'none',
    fontSize: '16px',

    '& .MuiNativeSelect-select': {
      height: '56px',
      padding: '0',
      '&:focus': {
        background: 'none',
      },
    },

    '& .MuiInput-input': {
      paddingLeft: theme.spacing(2),
      '-webkit-margin-start': theme.spacing(1),
      '-webkit-padding-start': theme.spacing(1),
    },

    '&.Mui-error': {
      borderColor: theme.palette.brandRed.dark,
    },

    '&.Mui-focused': {
      border: `2px solid ${theme.palette.brandBlue.dark}`,
      background: 'none',
      boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.25)',
    },
  },

  icon: {
    zIndex: -1,
    fill: theme.palette.brandRed.dark,
    marginRight: '15px',
  },

  formControl: {
    marginBottom: theme.spacing(3),
    width: '100%',

    '& .MuiFormControl-root': {
      marginBottom: theme.spacing(1),

      '&:last-child': {
        marginBottom: 0,
      },
    },
  },
}));
